module.exports = __webpack_public_path__ + "static/img/1_3_1.9a7a9557.png";